/** Rótulo curto para `DocumentWorkflow.Source` (painel de detalhes). */
export function translateDocumentWorkflowSource(source: string | undefined): string {
  switch ((source || '').trim()) {
    case 'Manual':
      return 'Seleção manual';
    case 'Template':
      return 'Template do documento';
    case 'Extension':
      return 'Extensão do arquivo';
    case 'Folder':
      return 'Pasta';
    case 'Default':
      return 'Padrão da empresa';
    default:
      return source?.trim() || '—';
  }
}

/** Linha de origem para o modal de sugestão (GET /suggest). */
export function formatWorkflowSuggestionBadge(
  source: string | undefined,
  ruleLabel: string | null | undefined,
  workflowName: string | null | undefined
): string {
  const s = (source || '').trim();
  const label = (ruleLabel || '').trim();

  if (s === 'Manual' && label) {
    return `Seleção manual: ${label}`;
  }
  if (s === 'Template' && label) {
    return `Sugerido pelo template — ${label}`;
  }
  if (s === 'Extension' && label) {
    return `Sugerido pela extensão — ${label}`;
  }
  if (s === 'Folder' && label) {
    return `Sugerido pela pasta — ${label}`;
  }
  if (s === 'Default') {
    return 'Workflow padrão da empresa';
  }
  if (!workflowName && !s) {
    return 'Nenhum workflow sugerido — você pode escolher manualmente';
  }
  return label || workflowName || '—';
}
